export default {
  title: 'Gestionați contul',
  buttons: {
    save: 'Salvați',
    delete: 'Ștergeți',
  },
};
